<template>
  <div class="page">
    <div class="page-header page-header--row">
      <div>
        <h1>Materiais</h1>
        <p>Gerencie os materiais e o estoque</p>
      </div>
      <div class="header-actions">
        <button class="btn btn-secondary" @click="abrirModalEntrada">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
            width="15"
            height="15"
          >
            <path d="M12 19V5M5 12l7-7 7 7" />
          </svg>
          Entrada de Estoque
        </button>
        <router-link to="/materiais/novo" class="btn btn-primary">
          <AppIcon
            name="mais"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            width="15"
            height="15"
          />
          Novo Material
        </router-link>
      </div>
    </div>

    <div class="card">
      <div class="filters-bar">
        <div class="search-wrapper">
          <AppIcon
            name="busca"
            class="search-icon"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <input
            v-model="busca"
            type="text"
            placeholder="Buscar por nome ou cor…"
            class="search-input"
          />
        </div>
      </div>
      <div class="table-wrapper table-wrapper--cards">
        <table>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Cor</th>
              <th>Estoque</th>
              <th>Estoque Mínimo</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="materiaisFiltrados.length === 0">
              <td
                colspan="5"
                style="
                  text-align: center;
                  padding: 2rem;
                  color: var(--c-text-muted);
                "
                class="table-empty"
              >
                Nenhum material encontrado.
              </td>
            </tr>
            <tr v-for="material in materiaisFiltrados" :key="material.id">
              <td data-label="Nome">{{ material.nome }}</td>
              <td data-label="Cor">{{ getCorNome(material) }}</td>
              <td data-label="Estoque">
                {{ material.quantidade_estoque }} {{ material.unidade_medida }}
              </td>
              <td data-label="Estoque Mínimo">{{ material.estoque_minimo }}</td>
              <td data-label="">
                <div class="cell-actions">
                  <router-link
                    :to="`/materiais/${material.id}`"
                    class="btn btn-sm btn-secondary"
                    >Ver</router-link
                  >
                  <router-link
                    :to="`/materiais/${material.id}/editar`"
                    class="btn btn-sm btn-secondary"
                    >Editar</router-link
                  >
                  <button
                    class="btn btn-sm btn-danger"
                    @click="deletarMaterial(material.id)"
                  >
                    Deletar
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="successMessage" class="msg-success">{{ successMessage }}</div>
    <div v-if="errorMessage" class="msg-error">{{ errorMessage }}</div>

    <!-- Modal de Entrada de Estoque -->
    <AppModal
      v-if="modalAberto"
      titulo="Entrada de Estoque"
      @fechar="fecharModal"
    >
      <div class="form-group">
        <label for="material_selecionado">Material:</label>
        <select
          id="material_selecionado"
          v-model="entrada.material_id"
          required
        >
          <option value="" disabled>Selecione o material</option>
          <option
            v-for="material in materiais"
            :key="material.id"
            :value="material.id"
          >
            {{ material.nome }} - {{ getCorNomeSelect(material) }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="quantidade_entrada">Quantidade:</label>
        <input
          id="quantidade_entrada"
          v-model.number="entrada.quantidade"
          type="number"
          step="0.01"
          min="0"
          placeholder="Quantidade a adicionar"
          required
        />
      </div>
      <template #rodape>
        <button class="btn btn-secondary" @click="fecharModal">Cancelar</button>
        <button class="btn btn-primary" @click="confirmarEntrada">
          Confirmar Entrada
        </button>
      </template>
    </AppModal>
  </div>
</template>

<script>
import materiaisService from "@/services/materiais";

export default {
  name: "MateriaisView",
  data() {
    return {
      materiais: [],
      busca: "",
      modalAberto: false,
      entrada: {
        material_id: null,
        quantidade: null,
      },
      successMessage: "",
      errorMessage: "",
    };
  },
  computed: {
    materiaisFiltrados() {
      const t = this.busca.toLowerCase();
      if (!t) return this.materiais;
      return this.materiais.filter(
        (m) =>
          (m.nome || "").toLowerCase().includes(t) ||
          (m.cor || "").toLowerCase().includes(t)
      );
    },
  },
  created() {
    this.fetchMateriais();
  },
  methods: {
    getCorNome(material) {
      return material.cor || "-";
    },
    getCorNomeSelect(material) {
      return material.cor || "Sem cor";
    },
    async fetchMateriais() {
      try {
        const response = await materiaisService.getAll();
        this.materiais = [...response.data].sort((a, b) =>
          (a.nome || "").localeCompare(b.nome || "", "pt-BR")
        );
      } catch (error) {
        this.errorMessage = "Erro ao carregar materiais.";
      }
    },
    async deletarMaterial(id) {
      if (confirm("Tem certeza que deseja deletar este material?")) {
        try {
          await materiaisService.destroy(id);
          this.successMessage = "Material deletado com sucesso!";
          this.errorMessage = "";
          this.fetchMateriais();
        } catch (error) {
          this.errorMessage = "Erro ao deletar material.";
          this.successMessage = "";
        }
      }
    },
    abrirModalEntrada() {
      this.modalAberto = true;
      this.entrada = { material_id: null, quantidade: null };
    },
    fecharModal() {
      this.modalAberto = false;
      this.entrada = { material_id: null, quantidade: null };
    },
    async confirmarEntrada() {
      if (
        !this.entrada.material_id ||
        !this.entrada.quantidade ||
        this.entrada.quantidade <= 0
      ) {
        this.errorMessage =
          "Selecione um material e informe uma quantidade válida.";
        return;
      }

      try {
        await materiaisService.entradaEstoque(
          this.entrada.material_id,
          this.entrada.quantidade
        );
        this.successMessage = `Entrada de ${this.entrada.quantidade} unidades realizada com sucesso!`;
        this.errorMessage = "";
        this.fecharModal();
        this.fetchMateriais();
      } catch (error) {
        this.errorMessage = "Erro ao dar entrada no estoque.";
      }
    },
  },
};
</script>

<style scoped>
.header-actions {
  display: flex;
  gap: 0.625rem;
  align-items: center;
}

.filters-bar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--c-border-light);
}

.cell-actions {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.table-wrapper {
  overflow-x: auto;
}

@media (max-width: 640px) {
  .header-actions {
    flex-direction: column;
    gap: 0.5rem;
  }

  .header-actions .btn,
  .header-actions a.btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
